class ApiError extends Error {
  /**
   * @param {string} message
   * @param {string} code
   */
  constructor(message, code) {
    super();

    this.message = message;
    this.code = code;
  }
}

export default ApiError;
